module.exports = __webpack_public_path__ + "img/l4-sms-outline.8db680b0.svg";